/**
 * API Configuration
 * Centralized API endpoint configuration using environment variables
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.mtsolar.co.uk';

// Document server URL - for PDF viewing and document access
// In production this should point to api.mtsolar.co.uk
const DOC_SERVER_URL = process.env.REACT_APP_DOC_SERVER_URL || API_BASE_URL;

export const apiConfig = {
  baseUrl: API_BASE_URL,
  endpoints: {
    // Auth endpoints
    signin: `${API_BASE_URL}/auth/signin/`,
    signout: `${API_BASE_URL}/auth/signout/`,

    // User endpoints
    users: `${API_BASE_URL}/users/`,

    // Main API endpoints
    battery: `${API_BASE_URL}/battery`,
    accontroller: `${API_BASE_URL}/accontroller`,
    tariff: `${API_BASE_URL}/tariff`,
    panel: `${API_BASE_URL}/panel`,
    financerate: `${API_BASE_URL}/financerate`,
    installationareas: `${API_BASE_URL}/installationareas`,
    maintenanceoptions: `${API_BASE_URL}/maintenanceoptions`,
    flg: `${API_BASE_URL}/flg/`,
    presenterslides: `${API_BASE_URL}/presenterslides/`,
    pdfMerge: `${API_BASE_URL}/pdfMerge/`,
    mergeFiles: `${API_BASE_URL}/MergeFiles/`,
    mergeOrderForm: `${API_BASE_URL}/MergeOrderForm/`,
    getJSONMappings: `${API_BASE_URL}/GetJSONMappings`,
    picupload: `${API_BASE_URL}/picupload/`,
    mergeImages: `${API_BASE_URL}/MergeImages/`,
    quotes: `${API_BASE_URL}/quotes/`,
    createAdobeAgreement: `${API_BASE_URL}/CreateAdobeAgreement`,
    solarOptimisers: `${API_BASE_URL}/SolarOptimisers`,
    evchargers: `${API_BASE_URL}/evchargers`,
    inverterSearch: `${API_BASE_URL}/inverter_search`,
    ancillary: `${API_BASE_URL}/ancillary`,
    fixedcosts: `${API_BASE_URL}/fixedcosts`,
    pricing: `${API_BASE_URL}/pricing/`,
    sites: `${API_BASE_URL}/sites/`,
  }
};

export default apiConfig;
